module.exports = __webpack_public_path__ + "img/maritime_scene.040a7164.png";